"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1839],{

/***/ 51839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ myAddress_MyAddress; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./api/memberAddress.js
var memberAddress = __webpack_require__(36910);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./common/util/addressYup.js
var addressYup = __webpack_require__(38594);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/mypage/myAddress/MyAddress-styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin: 0 0 30px 0;\n\n  .add-address-btn {\n    border: none;\n    background: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    color: #253d4e;\n    & span {\n      transition: all 0.1s;\n    }\n    :hover {\n      color: #3bb77e;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 5px;\n  grid-row-gap: 5px;\n  @media (max-width: 1025px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: #fff;\n  border: 1px solid #ececec;\n  border-radius: 15px;\n  overflow: hidden;\n  transition: 0.2s;\n  -moz-transition: 0.2s;\n  -webkit-transition: 0.2s;\n  -o-transition: 0.2s;\n  margin-bottom: 0.7rem;\n  margin-right: 0.7rem;\n  width: 100%;\n  cursor: pointer;\n  :hover {\n    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);\n    border: 1px solid #bce3c9;\n    transition: 0.2s;\n    -moz-transition: 0.2s;\n    -webkit-transition: 0.2s;\n    -o-transition: 0.2s;\n  }\n\n  .product-badges.product-badges-position {\n    position: absolute;\n    right: 0;\n    top: 0px;\n    z-index: 9;\n    > span {\n      display: inline-block;\n      font-size: 12px;\n      line-height: 1;\n      border-radius: 0px 10px 0 20px;\n      color: #fff;\n      padding: 9px 20px 10px 20px;\n      background-color: #f74b81;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 20px 30px 20px;\n\n  .address-info {\n    font-size: 14px;\n    color: #253d4e;\n\n    & li:not(:last-child) {\n      margin-bottom: 4px;\n      img {\n        margin-right: 8px;\n        max-width: 16px;\n      }\n    }\n  }\n  .basic-btns {\n    display: flex;\n    margin-right: 10px;\n    margin-bottom: 10px;\n  }\n\n  .address-btn {\n    display: flex;\n    margin-top: 1rem;\n    justify-content: space-between;\n    flex-wrap: wrap;\n\n    .select-btns {\n      display: flex;\n      margin-right: 10px;\n      margin-bottom: 10px;\n    }\n\n    & button {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      min-width: 3.2rem;\n      font-size: 14px;\n      font-weight: 400;\n      padding: 5px 20px;\n      border-radius: 5px;\n      word-break: keep-all;\n      background-color: #fff;\n      color: #253d4e;\n      border: 1px solid #253d4e;\n      :hover {\n        background-color: #253d4e;\n        color: #fff;\n      }\n    }\n\n    .btn-select {\n      border: none;\n      background-color: #3bb77e;\n      color: #fff;\n      :hover {\n        background-color: #fd7e14;\n      }\n    }\n\n    .btn-select-basic {\n      border: none;\n      background-color: #3bb77e;\n      color: #fff;\n      padding: 0 10px;\n      margin: 0;\n      :hover {\n        background-color: #f1c40f;\n      }\n    }\n\n    & button:not(:last-of-type) {\n      margin-right: 10px;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-6746e27f-0"
})(_templateObject());
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6746e27f-1"
})(_templateObject1());
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6746e27f-2"
})(_templateObject2());
var AddressBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6746e27f-3"
})(_templateObject3());
var AddressContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6746e27f-4"
})(_templateObject4());

// EXTERNAL MODULE: ./components/mypage/myAddress/new/MyAddress-new.js + 1 modules
var MyAddress_new = __webpack_require__(65523);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
;// CONCATENATED MODULE: ./components/mypage/myAddress/MyAddress.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var MyAddress = function(param) {
    var _$isLoaded = param.isLoaded, loading = param.loading, ownProps = param.ownProps;
    var router = (0,next_router.useRouter)();
    // api 통신 데이터
    var ref7 = (0,react.useState)(), myAddress = ref7[0], setMyAddress = ref7[1];
    var ref1 = (0,react.useState)(0), myAddressCount = ref1[0], setMyAddressCount = ref1[1];
    // 등록 & 수정 관련
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var ref3 = (0,react.useState)({
        addressGps: {
            mapx: "",
            mapy: ""
        }
    }), mapInputs = ref3[0], setMapInputs = ref3[1];
    var ref4 = (0,react.useState)(false), isEdit = ref4[0], setIsEdit = ref4[1];
    var ref5 = (0,react.useState)(), editAddress = ref5[0], setEditAddress = ref5[1];
    // api
    var fetchAddressList = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref6, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return (0,memberAddress/* fetchListMemberAddress */.F8)();
                    case 3:
                        res = _ctx.sent;
                        setMyAddressCount((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Count);
                        setMyAddress((ref6 = res.Data) === null || ref6 === void 0 ? void 0 : ref6.Rows);
                        _$isLoaded();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchAddressList() {
            return _ref.apply(this, arguments);
        };
    }();
    var deleteAddress = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(acode) {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "DeleteSet",
                            acode: acode
                        };
                        _ctx.next = 3;
                        return (0,memberAddress/* deleteMemberAddress */.ZT)(body);
                    case 3:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.code) === "0000") {
                            (0,common_alert/* successAlert */.Cq)("\uC0AD\uC81C \uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            fetchAddressList();
                        } else {
                            ;
                            (0,common_alert/* failAlert */.qh)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Msg);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteAddress(acode) {
            return _ref.apply(this, arguments);
        };
    }();
    // 기본 배송지 등록
    var selectDefault = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(acode) {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "DefaultSet",
                            acode: acode
                        };
                        _ctx.next = 3;
                        return (0,memberAddress/* defaultSetAddress */.$)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.code === "0000") {
                            (0,common_alert/* successAlert */.Cq)("\uC124\uC815\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            fetchAddressList();
                        } else {
                            (0,common_alert/* failAlert */.qh)(res.data.Msg);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function selectDefault(acode) {
            return _ref.apply(this, arguments);
        };
    }();
    // 수정하기
    var handleIsEdit = function(el) {
        setIsEdit(true);
        setIsOpen(true);
        setEditAddress(el);
    };
    (0,react.useEffect)(function() {
        fetchAddressList();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loading === false && (!isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                            children: [
                                "\uCD1D ",
                                myAddressCount,
                                " \uAC1C"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "add-address-btn",
                            onClick: function() {
                                return setIsOpen(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "fi-rs-plus"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pl-10 font-md",
                                    children: "\uBC30\uC1A1\uC9C0 \uB4F1\uB85D"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                    children: myAddress === null || myAddress === void 0 ? void 0 : myAddress.map(function(el, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressBox, {
                            children: [
                                el.basic === "Y" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-badges product-badges-position",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "\uAE30\uBCF8 \uBC30\uC1A1\uC9C0"
                                    })
                                }) : "",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressContent, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                            className: "address-info",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "\uBC30\uC1A1\uC9C0 \uBA85: "
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: el.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "\uB3C4\uB85C\uBA85 \uC8FC\uC18C:"
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: el.doro_addr
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "\uC9C0\uBC88 \uC8FC\uC18C: "
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: el.base_addr
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "\uC0C1\uC138 \uC8FC\uC18C: "
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: el.detail_addr
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: "\uC6B0\uD3B8\uBC88\uD638: "
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: el.zipcode
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "address-btn",
                                            children: [
                                                ownProps.isCheckout ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "select-btns",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn-select",
                                                            type: "button",
                                                            onClick: function() {
                                                                ownProps.setMemberAddress(el);
                                                                ownProps.setUserInputs(_objectSpread({}, ownProps.userInputs, {
                                                                    acode: el.acode,
                                                                    base_addr: el.base_addr,
                                                                    detail_addr: el.detail_addr,
                                                                    doro_addr: el.doro_addr,
                                                                    addressGps: {
                                                                        mapx: el.mapx,
                                                                        mapy: el.mapy
                                                                    },
                                                                    addr_name: el.name,
                                                                    zipcode: el.zipcode
                                                                }));
                                                                ownProps.setOpenAddressModal(false);
                                                            },
                                                            children: "\uC801\uC6A9"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn-select-basic",
                                                            onClick: function() {
                                                                selectDefault(el.acode);
                                                            },
                                                            children: "\uAE30\uBCF8 \uBC30\uC1A1\uC9C0\uB85C \uB4F1\uB85D"
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "btn-select-basic",
                                                        onClick: function() {
                                                            selectDefault(el.acode);
                                                        },
                                                        children: "\uAE30\uBCF8 \uBC30\uC1A1\uC9C0\uB85C \uB4F1\uB85D"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "basic-btns",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn",
                                                            type: "button",
                                                            onClick: function() {
                                                                return handleIsEdit(el);
                                                            },
                                                            children: "\uC218\uC815"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            className: "btn",
                                                            type: "button",
                                                            onClick: function() {
                                                                return deleteAddress(el.acode);
                                                            },
                                                            children: "\uC0AD\uC81C"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MyAddress_new/* default */.Z, {
            isCheckout: ownProps.isCheckout,
            setIsOpen: setIsOpen,
            isEdit: isEdit,
            setIsEdit: setIsEdit,
            isOpen: isOpen,
            editAddress: editAddress,
            fetchAddressList: fetchAddressList,
            deleteAddress: deleteAddress
        }))
    });
};
var mapStateToProps = function(state, ownProps) {
    return {
        loading: state.loading.loading,
        ownProps: ownProps
    };
};
var mapDispatchToProps = {
    isLoaded: loading/* isLoaded */.k
};
/* harmony default export */ var myAddress_MyAddress = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(MyAddress));


/***/ })

}]);